// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"2211c889","639":"e1dff5bf","787":"d34f1ef3","898":"04f610c0"}[chunkId] + ".chunk.js";
};